import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import ReactJson from 'react-json-view'

import {StripePayout} from './StripePayout';
import {StreetTeamPayouts} from './StreetTeamPayouts';
import {db} from '../../firebase';
import { DescriptionList } from '../../components/DescriptionList';

const RangerInfo = ({user, enableStreetTeam, disableStreetTeam, disableStreetTeamLegacy}) => {
  return (
    <div className='my-2'>
      <DescriptionList
        data={user.data()}
        description_schemas={[
          {
            label: 'ID',
            value: user.id,
          },
          {
            label: 'Email',
            attribute: 'email',
          },
          {
            label: 'Name',
            attribute: 'displayName',
          },
          {
            label: 'Street Team',
            attribute: 'streetTeam',
          },
          {
            label: 'Street Team Enabled At',
            timestamp_attribute: 'streetTeamEnabledAt',
          },
          {
            label: 'Street Team Legacy',
            attribute: 'streetTeamLegacy',
          },
          {
            label: 'Market',
            attribute: 'streetTeamMarket',
          },
          {
            label: 'Cell Phone',
            attribute: 'streetTeamPhone',
          },
          {
            label: 'Admin',
            attribute: 'admin',
          },
          {
            label: 'Stripe',
            render_func: ({stripeConnectAccountId}) => {
              if (stripeConnectAccountId) {
                return (
                  <a href={`https://dashboard.stripe.com/applications/users/${stripeConnectAccountId}`}>
                    {stripeConnectAccountId}
                  </a>
                )
              }

              return <span>No account</span>;
            },
          },
          {
            label: 'Signed Up',
            timestamp_attribute: 'creationTime',
          },
          {
            label: 'Last Signed In',
            timestamp_attribute: 'lastSeenAt',
          },
        ]}
      />

      <div className='my-2'>
        {!user.data().streetTeam ? (
          <div className='btn btn-primary btn-sm' onClick={enableStreetTeam}>
            Enable Street Team
          </div>
        ) : (
          <div className='btn btn-warning btn-sm' onClick={disableStreetTeam}>
            Disable Street Team
          </div>
        )}
      </div>

      <div>
        {user.data().streetTeamLegacy && (
          <div className='btn btn-warning btn-sm' onClick={disableStreetTeamLegacy}>
            Disable Street Team Legacy
          </div>
        )}
      </div>
    </div>
  )
}


class RangerOnboardingSteps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      streetTeamOnboardingSteps: null,
    };
  }

  componentDidMount = () => {
    const {userId} = this.props;
    db
      .collection('streetTeamOnboardingSteps')
      .where('userId', '==', userId)
      .onSnapshot((onboardingStepsQuery) => {
        const streetTeamOnboardingSteps = _.sortBy(onboardingStepsQuery.docs, (onboardingStep) => (
          onboardingStep.data().createdAt
        ))

        this.setState({
          streetTeamOnboardingSteps,
          isLoading: false,
        })
      })
  }

  render() {
    const {isLoading, streetTeamOnboardingSteps} = this.state;

    if (isLoading) {
      return <div>Loading onboarding steps...</div>
    }

    return (
      <div>
        <h3>Onboarding Steps</h3> 

        {streetTeamOnboardingSteps.map((onboardingStep) => {
          const {id} = onboardingStep;
          const {stepName} = onboardingStep.data();
          const data = _.mapValues( onboardingStep.data(), (val) => {
            if (typeof val !== 'object') {
              return val;
            }

            const type = val.constructor.name;
            if (type !== 'Timestamp') {
              return val;
            }

            return moment(val.toDate()).fromNow();
          });

          return (
            <div className='my-2' key={id}>
              <strong>Onboarding Step - {stepName}</strong>

              <ReactJson src={data} />
            </div>
          );
        })}
        
      </div>
    );
  }
}

RangerOnboardingSteps.propTypes = {
  userId: PropTypes.string.isRequired,
};

class StreetTeamMemberPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      isLoading: true,
    }
  }

  componentDidMount = async() =>{
    await this.loadUser();
  }

  loadUser = async() => {
    const {userId} = this.props.match.params;
    const user = await db.collection('users').doc(userId).get();

    this.setState({
      isLoading: false,
      user,
    })
  }

  enableStreetTeam = async (enable = true) => {
    const {userId} = this.props.match.params;

    await db.collection('users').doc(userId).set({
      streetTeam: !!enable,
      streetTeamEnabledAt: new Date(),
    }, {merge: true});

    window.location.reload();
  }

  disableStreetTeamLegacy = async () => {
    const {userId} = this.props.match.params;

    await db.collection('users').doc(userId).set({
      streetTeamLegacy: false,
    }, {merge: true});

    window.location.reload();
  }

  render() {
    const {isLoading, user} = this.state;

    if (isLoading) {
      return (
        <div>
          Loading...
        </div>
      )
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col">
            <h1>Ranger Info</h1>

            <RangerInfo
              user={user}
              enableStreetTeam={() => this.enableStreetTeam(true)}
              disableStreetTeam={() => this.enableStreetTeam(false)}
              disableStreetTeamLegacy={this.disableStreetTeamLegacy}
            />

            <hr />

            <RangerOnboardingSteps userId={user.id} />

            <hr />

            <StripePayout userId={user.id} />

            <hr />

            <StreetTeamPayouts userId={user.id} />
          </div>
        </div>
      </div>
    )
  }
}

StreetTeamMemberPage.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

export {StreetTeamMemberPage};



// WEBPACK FOOTER //
// ./src/street-team/member-profile/StreetTeamMemberPage.js